@if (loading()) {
  <div class="flex items-center gap-2 text-surface-500 py-6 justify-center">
    <i class="fas fa-spinner fa-spin"></i>
    {{ 'common.loading' | translate }}
  </div>
} @else if (rows().length === 0) {
  <div class="text-surface-500 py-6 text-center" data-testid="vat-history-empty">
    {{ 'address.vat-history-empty' | translate }}
  </div>
} @else {
  <p class="text-surface-500 mb-3" data-testid="vat-history-instruction">
    {{ 'address.vat-history-instruction' | translate }}
  </p>
  <p-table [value]="rows()" [scrollable]="true" scrollHeight="60vh" data-testid="vat-history-table">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'common.date' | translate }}</th>
        <th>{{ 'address.vat-field-requested-id' | translate }}</th>
        <th>{{ 'address.vat-field-result' | translate }}</th>
        <th>{{ 'address.vat-col-type' | translate }}</th>
        <th>{{ 'common.name' | translate }}</th>
        <th>{{ 'address.vat-col-consultation' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr class="cursor-pointer" (click)="openReport(row)">
        <td data-testid="vat-history-date">{{ historyDate(row) | localeDate: 'medium' }}</td>
        <td>{{ row.requestedVatId }}</td>
        <td>
          <div class="flex flex-col gap-1">
            <p-tag [severity]="resultSeverity(row)" [value]="resultLabel(row) | translate" />
            @if (row.errorDetail) {
              <span class="text-xs text-surface-500" data-testid="vat-history-error-detail">{{ row.errorDetail }}</span>
            }
          </div>
        </td>
        <td>{{ checkTypeLabel(row) | translate }}</td>
        <td>{{ row.recipient }}</td>
        <td>{{ row.requestIdentifier || '—' }}</td>
      </tr>
    </ng-template>
  </p-table>
}

<ng-template phxDialogButtons>
  <div class="flex justify-end">
    <p-button severity="secondary" [label]="'common.close' | translate" (onClick)="close()" data-testid="vat-history-close" />
  </div>
</ng-template>
